export default "__VITE_ASSET__DPaU14uq__"